import OrderIssuesService from "./OrderIssues";
import AuthService from "./auth";
import ClientService from "./clients";
import EmployeeService from "./employees";
import IssueTypesService from "./issueTypes";
import NotificationService from "./notifications";
import RecieptsService from "./orders";
import BranchService from "./branches";
import ReportsService from "./reports";
import ScheduleService from "./schedule";
import StatusService from "./statuses";
import VipService from "./vip";

export default class EndPoints {
  public static auth = new AuthService();
  public static branch = new BranchService();
  public static employee = new EmployeeService();
  public static client = new ClientService();
  public static order = new RecieptsService();
  public static status = new StatusService();
  public static vip = new VipService();
  public static reports = new ReportsService();
  public static issueType = new IssueTypesService();
  public static orderIssue = new OrderIssuesService();
  public static notification = new NotificationService();
  public static schedule = new ScheduleService();
}
